import type { HTMLAttributes, ReactNode } from 'react';
import { useTheme } from '../../theme';

export interface StudentDashboardMainAsideLayoutProps
  extends HTMLAttributes<HTMLDivElement> {
  main: ReactNode;
  aside: ReactNode;
}

export function StudentDashboardMainAsideLayout({
  main,
  aside,
  style,
  ...rest
}: StudentDashboardMainAsideLayoutProps) {
  const theme = useTheme();
  const L = theme.layout.studentDashboard;
  const mainMaxWidth = theme.palette.studentDashboard.xpBanner.width;

  return (
    <div
      style={{
        display: 'flex',
        gap: theme.spacing.lg,
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        ...style,
      }}
      {...rest}
    >
      <main
        style={{
          flex: `1 1 ${L.mainFlexBasis}`,
          minWidth: 0,
          maxWidth: mainMaxWidth,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing.lg,
        }}
      >
        {main}
      </main>
      {aside}
    </div>
  );
}
